import { useEffect, useState } from 'react';

import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';

import BreadcrumbsCustom from 'src/components/common/BreadcrumbsCustom';
import Record from 'src/components/master/doctorFee/Record';
import BtnGradient from 'src/components/common/button/BtnGradient';

import { getAPI, postAPI } from 'src/utils/api';
import { getToken } from 'src/utils/auth';
import { getField } from 'src/common/helper';
import { useNotify } from 'src/context/ContextNotify';


const breadcrumbsDefine = [
  {
    to: '/',
    label: '会計'
  },
  {
    label: '医師価格設定'
  }
];

const DoctorFee = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [datas, setDatas] = useState<any[]>([]);
  const notifyContext = useNotify();

  const handleChange = (index: number, fieldName: string, value: number | null) => {
    setDatas((prevDatas) => {
      return prevDatas.map((data, idx) => {
        if (idx === index) {
          return {
            ...data,
            [fieldName]: value,
          };
        }
        return data;
      });
    });
  };

  const getDoctorSurgeryRate = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      setIsLoading(true);
      getAPI(`/master/doctor-surgery-rate?token=${token}`)
        .then((res: any) => {
          if (res.code === 200 && res.data) {
            setDatas(getField(res.data, 'items', []));
          }
          if (res.code === 500) {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error'
            })
          }
        })
        .finally(() => {
          setIsLoading(false);
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  const handleSave = () => {
    try {
      const token = getToken();

      if (!token) {
        throw new Error('Failed to get access token');
      }

      const data = {
        configs: datas
      };

      postAPI(`/master/doctor-surgery-rate-save?token=${token}`, data)
        .then((res: any) => {
          if (res.code === 200) {
            notifyContext.setNotifyMessage({
              show: true,
              message: '設定を変更しました',
              type: 'success'
            })
          } else {
            notifyContext.setNotifyMessage({
              show: true,
              message: res.msg,
              type: 'error'
            })
          }
        })
        .finally(() => {
        });
    } catch (error) {
      console.error('Failed to fetch data:', error);
      throw error;
    }
  };

  useEffect(() => {
    getDoctorSurgeryRate();

    // eslint-disable-next-line
  }, []);

  return (
    <Box sx={{ width: '100%' }}>
      <BreadcrumbsCustom breadcrumbs={breadcrumbsDefine} />
      <Box
        sx={{
          mt: '18px',
          height: 'calc(100vh - 140px)',
          width: '100%'
        }}
      >
        <Typography
          component='label'
          sx={{
            fontWeight: '500',
            fontSize: '20px',
            lineHeight: '24px'
          }}
        >
          {'医師価格設定'}
        </Typography>

        <Box
          sx={{
            my: '20px'
          }}
        >
          <Record
            items={datas}
            isLoading={isLoading}
            onChange={handleChange}
          />
        </Box>

        <BtnGradient
          text='登録'
          handleButtonClick={handleSave}
        />
      </Box>
    </Box>
  );
}

export default DoctorFee;